"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Add = Add;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function Add({
  color,
  size = 1,
  variant = 'solid'
}) {
  if (variant === 'solid') {
    return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
      heightAndWidth: size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M15 9V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v5H4a1 1 0 00-1 1v4a1 1 0 001 1h5v5a1 1 0 001 1h4a1 1 0 001-1v-5h5a1 1 0 001-1v-4a1 1 0 00-1-1h-5z",
      fillColor: color
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M20 8h-4V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v4H4a2 2 0 00-2 2v4a2 2 0 002 2h4v4a2 2 0 002 2h4a2 2 0 002-2v-4h4a2 2 0 002-2v-4a2 2 0 00-2-2zm0 6h-6l-.003 6H10v-6H4v-4h6V4h4v6h6v4z",
    fillColor: color
  }));
}